import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locale/en.json";
import faTranslation from "./locale/fa.json";

// Load language manually from cookie (or fallback to "fa")
const getLangFromCookie = () => {
  const match = document.cookie.match(/(?:^|; )i18next=([^;]*)/);
  return match ? match[1] : "fa";
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      fa: { translation: faTranslation },
    },
    lng: getLangFromCookie(),      // 👈 manually set the language
    fallbackLng: "fa",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
